/**
 * OAuth callback handler
 * Processes the redirect from auth.braindance.net
 */
import { SsoCallback } from '@codespeak11/cognito-passwordless';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';

export default function AuthCallback() {
  const navigate = useNavigate();

  return (
    <SsoCallback
      onSuccess={(returnPath) => navigate(returnPath || '/', { replace: true })}
      onLoginRequired={() => navigate('/login', { replace: true })}
      onError={(error) => {
        console.error('Auth callback error:', error);
        navigate('/login', { replace: true });
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          gap: 2,
        }}
      >
        <CircularProgress />
        <Typography variant="body2" color="text.secondary">
          Signing you in...
        </Typography>
      </Box>
    </SsoCallback>
  );
}
